




































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';

@Component
export default class LocalSettings extends Vue {
    private status!: string;

    private data() {
        return {
            status: '',
        };
    }

    private created() {
        this.$store.state.mobileSidebarVisible = false;
        this.$store.state.menuVisible = false;
    }

    private resetMainColor() {
        this.$store.state.colors.mainColor = '#1E7832';
    }

    private resetAccentColor() {
        this.$store.state.colors.accentColor = '#B46432';
    }

    @Watch('$store.state.personal.lang')
    private onPropertyChanged(value: string, oldValue: string) {
        if (this.$store.state.personal.lang === 'browser') {
            this.$i18n.locale = navigator.language;
        } else {
            this.$i18n.locale = this.$store.state.personal.lang;
        }
        localStorage.setItem('lang', this.$store.state.personal.lang);
    }

    @Watch('$store.state.personal.date')
    private onPropertyChanged1(value: string, oldValue: string) {
        localStorage.setItem('date', this.$store.state.personal.date);
    }

    @Watch('$store.state.personal.theme')
    private onPropertyChanged2(value: string, oldValue: string) {
        localStorage.setItem('theme', this.$store.state.personal.theme);
    }

    @Watch('$store.state.colors.mainColor')
    private onPropertyChanged3(value: string, oldValue: string) {
        document.documentElement.style.setProperty('--theme-color', this.$store.state.colors.mainColor);
        localStorage.setItem('mainColor', this.$store.state.colors.mainColor);
    }

    @Watch('$store.state.colors.accentColor')
    private onPropertyChanged4(value: string, oldValue: string) {
        document.documentElement.style.setProperty('--accent-color', this.$store.state.colors.accentColor);
        localStorage.setItem('accentColor', this.$store.state.colors.accentColor);
    }

}
